import { SHOW_UI_EXAMPLES } from 'settings/showUIExamples'

// TODO: should use .startsWith
export const routeRequiresAuth = (route: string = window.location.pathname) => {
  if (SHOW_UI_EXAMPLES && route.toLowerCase().startsWith('/ui-examples')) return false

  if (route.toLowerCase().startsWith('/login')) return false

  if (route.toLowerCase().startsWith('/reset')) return false

  return true
}
